module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"loading-data":"Daten werden geladen"},"fr":{"loading-data":"Les données sont chargées"},"it":{"loading-data":"I dati vengono caricati"}}')
  delete Component.options._Ctor
}
